import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { permissions } from "../../utils/permissions";
import { DataTable } from "../DisplayTable/DataTable";
import { Button, Dropdown, DropdownButton } from "react-bootstrap";
import { usePermissionAndDomain } from "../../hooks/usePermissionAndDomain";
import { PageCount } from "../DisplayTable/PageCount";

export const DriversDataTable = ({ drivers }) => {
  const { hasPermission } = usePermissionAndDomain();

  const columns = [
    {
      id: "name",
      header: "NAME",
      cell: ({ row }) => {
        const driver = row.original;
        return (
          <>
            {`${driver?.first_name} ${driver?.middle_name} ${driver?.surname}` || "N/A"}
          </>
        );
      },
    },

    {
      id: "office_location",
      header: "LOCATION",
      cell: ({ row }) => {
        const driver = row.original;
        return (
          <>
            {!!driver?.office_location ?
              `${driver?.office_location?.name}`
              : "N/A"}
          </>
        );
      },
    },

    {
      id: "phone",
      header: "CONTACTS",
      cell: ({ row }) => {
        const driver = row.original;
        return (
          <>
            {!!driver?.phone ?
              `${driver?.phone}`
              : "N/A"}
          </>
        );
      },
    },

    {
      id: "license_number",
      header: "LICENSE",
      cell: ({ row }) => {
        const driver = row.original;
        return (
          <>
            {!!driver?.license_number ?
              `${driver?.license_number}`
              : "N/A"}
          </>
        );
      },
    },

    {
      id: "license_expiry_date",
      header: "LICENSE EXPIRY DATE",
      cell: ({ row }) => {
        const driver = row.original;
        return (
          <>
            {!!driver?.license_expiry_date ?
              `${driver?.license_expiry_date}`
              : "N/A"}
          </>
        );
      },
    },
    {
      id: "actions",
      cell: ({ row }) => {
        const driver = row.original;

        return (
          <DropdownButton id="dropdown-basic-button" title="ACTION" align="end">
            {hasPermission(permissions.VIEWS) && (
              <Dropdown.Item
                as={Link}
                to={`/drivers/view/${driver.id}`}
                size="sm"
                className="justify-content-start"
              >
                View
              </Dropdown.Item>
            )}

            {hasPermission(permissions.EDIT_DRIVER_DOCUMENTS) && (
              <Dropdown.Item
                as={Link}
                to={`/drivers/edit/${driver.id}`}
                size="sm"
                className="justify-content-start"
              >
                Edit
              </Dropdown.Item>
            )}
          </DropdownButton>
        );
      },
    },
  ];

  const data = drivers;

  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      columnFilters,
      globalFilter,
    },
  });

  return (
    <div className="rounded-md border">
      <div>
        <div className="flex items-center py-4 ms-4 me-4 ">
          <input
            placeholder="Filter input..."
            value={globalFilter ?? ""}
            onChange={(event) => {
              return setGlobalFilter(event.target.value);
            }}
            className="max-w-sm form-control"
          />
        </div>
      </div>

      <DataTable data={data} columns={columns} table={table} />

      <div className="flex items-center justify-end space-x-2 py-4">
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            table.previousPage();
          }}
          disabled={!table.getCanPreviousPage()}
        >
          Previous
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            table.nextPage();
          }}
          disabled={!table.getCanNextPage()}
        >
          Next
        </Button>

        <PageCount table={table} />
      </div>
    </div>
  );
};
